import React from 'react';
import AccountSidebar from '../components/AccountSidebar';
import ClosedPositionsContent from '../components/ClosedPositionsContent';

export default function ClosedPositions() {
    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="kapali-pozisyonlar" />
                    <ClosedPositionsContent />
                </div>
            </div>
        </div>
    );
}
